import { snakeCase, forEach } from "lodash"

export function generateCoverageQuery(resourceType, modelsDates) {
  let query

  switch (resourceType) {
    case "portfolio":
    case "swap":
    case "etf":
    case "index":
      query = "query($resourceType: PositionSetType, $resourceId: String) {"
      forEach(modelsDates, modelDates => {
        query += `${snakeCase(modelDates.id)}: model(id: "${modelDates.id}"){
          simulation(positionSet: {id: $resourceId type:$resourceType} from: "${modelDates.from}" to: "${modelDates.to}" interval: MONTHLY_START_DATES) {
            coverage {
              summary {
                percentGmvAvailable
              }
            }
          }
        }`
      })
      break
    case "security":
      query = "query($ticker: String, $mic: String, $internalId: String) {"
      forEach(modelsDates, modelDates => {
        query += `${snakeCase(modelDates.id)}: model(id: "${modelDates.id}"){
          security(ticker:$ticker, mic:$mic, internalId: $internalId) {
            descriptors(on:"${modelDates.to}") {
              modelProviderId
            }
          }
        }`
      })
  }

  query += "}"
  return query
}
